import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
import LogInModal from 'flarum/common/components/LogInModal';
import LinkButton from 'flarum/common/components/LinkButton';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

import Link from 'flarum/common/components/Link';

import LessonPlanDirectoryState from '../states/LessonPlanDirectoryState';
import CheckableButton from './CheckableButton';
import Separator from 'flarum/common/components/Separator';

import RelatedLessonPlan from './RelatedLessonPlan';

/**
 * This page re-uses Flarum's IndexPage CSS classes
 */
export default class LessonPlanPage extends Page {
  createModal() {
    if (!app.session.user) {
      return LogInModal;
    }
  }
  oninit(vnode) {
    if (!app.session.user) {
      this.visitor = true;
      setTimeout(() => app.modal.show(this.createModal()), 1000);
      return;
    }

    app.session.user.user_group = '';
    if (app.session.user) {
      app.session.user.groups().map(function (group, i) {
        if ('Mod' == group.nameSingular()) {
          app.session.user.user_group = 'Mod';
        } else if ('Admin' == group.nameSingular()) {
          app.session.user.user_group = 'Admin';
        }
      });
    }

    super.oninit(vnode);

    this.state = new LessonPlanDirectoryState(this.params());

    app.store.find('lesson-plans', m.route.param('id')).then((lesson_plan) => {
      app.setTitle(lesson_plan.title() + ' - Lesson Plan');
      app.setTitleCount(0);
    });

    this.state.refreshParams(this.params());

    this.bodyClass = 'LessonPlanPage';

    this.lesson_plan = {};

    app.history.push('lesson-plans', app.translator.trans('td-lesson-plans.forum.header.back_to_lesson_plans_directory_tooltip'));
  }

  view() {
    if (this.visitor) {
      return m('div');
    }
    if (this.state.isLoading()) {
      this.loading = LoadingIndicator.component();
    } else {
      this.loading = false;
    }

    let learning_outcomes = [];
    this.state.lesson_plans.map((lesson_plan) => {
      lesson_plan.learning_outcomes().map((learning_outcome) => {
        if (!learning_outcome.parent_id) {
          if (!learning_outcomes[learning_outcome.id]) {
            learning_outcomes[learning_outcome.id] = {};
          }
          learning_outcomes[learning_outcome.id].outcome = learning_outcome;
        } else {
          if (!learning_outcomes[learning_outcome.parent_id].children) {
            learning_outcomes[learning_outcome.parent_id].children = [];
          }
          learning_outcomes[learning_outcome.parent_id].children.push(learning_outcome);
        }
      });
    });

    return (
      <div className="IndexPage LessonPlan">
        {IndexPage.prototype.hero()}
        <div className="container LessonPlansWrap">
          {m(m.route.Link, { href: '/lesson-plans' }, '< Back to Lesson Plans')}

          {this.state.lesson_plans.map((lesson_plan) => {
            return (
              <div>
                <h1>{lesson_plan.title()}</h1>
                {'Admin' == app.session.user.user_group || 'Mod' == app.session.user.user_group
                  ? m('a.Button.mb-2', { href: '/admin#/extension/thedesktop-lesson-plans/edit/' + lesson_plan.id(), target: '_blank' }, 'Edit')
                  : ''}
              </div>
            );
          })}

          <div className="row">
            <div className="col-12 col-md-4 sidebar">
              {this.state.lesson_plans.map((lesson_plan) => {
                return (
                  <div>
                    <div>
                      {m('img', {
                        src: app.forum.attribute('baseUrl') + '/' + lesson_plan.thumbnail(),
                        class: 'featured-image',
                      })}
                    </div>
                    {lesson_plan.age_group() ? m('div.p-2.age_group', m('h3.my-0', 'Age group'), lesson_plan.age_group() + ' years') : ''}

                    {lesson_plan.activity_type()
                      ? m(
                          'div.p-2.activity_type',
                          m('h3.my-0', 'Activity type'),
                          lesson_plan.activity_type().title,
                          lesson_plan.activity_type2() && lesson_plan.activity_type2().id != lesson_plan.activity_type().id
                            ? m('div', lesson_plan.activity_type2().title)
                            : ''
                        )
                      : ''}

                    {lesson_plan.developmental_area()
                      ? m(
                          'div.p-2.developmental_area',
                          m('h3.my-0', 'Developmental area'),
                          lesson_plan.developmental_area().title,
                          lesson_plan.developmental_area2() && lesson_plan.developmental_area2().id != lesson_plan.developmental_area().id
                            ? m('div', lesson_plan.developmental_area2().title)
                            : ''
                        )
                      : ''}

                    <div className="mt-2">
                      <div className="learning-outcomes-wrap">
                        <h3 className="my-0">Learning outcomes</h3>
                        <ul className="unlisted px-0 mx-0 mt-0">
                          {learning_outcomes.map((learning_outcome) => {
                            let r = '<li class="mt-2"><span class="primary">' + learning_outcome.outcome.abbr + '</span>';
                            if (learning_outcome.children) {
                              r += '<ul>';
                              learning_outcome.children.map((child) => {
                                r += '<li>' + child.abbr + '</li>';
                              });
                              r += '</ul>';
                            }
                            r += '</li>';
                            return m.trust(r);
                          })}
                        </ul>
                      </div>
                    </div>

                    {lesson_plan.related_lesson_plans().length || lesson_plan.related_to().length
                      ? m(
                          'div.mt-2',
                          m(
                            'div.related-lesson-plans-wrap',
                            m('h3.my-0', 'Related Lesson Plans'),
                            m('div', { class: 'p-0 mx-0 mt-0 related-lesson-plans' }, [
                              lesson_plan.related_lesson_plans().map((related_lesson_plan) => {
                                return <RelatedLessonPlan related_lesson_plan={related_lesson_plan} />;
                              }),
                              lesson_plan.related_to().map((related_lesson_plan) => {
                                return <RelatedLessonPlan related_lesson_plan={related_lesson_plan} />;
                              }),
                            ])
                          )
                        )
                      : ''}

                    <div className="mt-2">
                      <a
                        href={app.route('lesson_plan_download', { id: lesson_plan.id() })}
                        target="_blank"
                        className="Button Button--primary Button--download mb-2"
                        style="display: block;"
                      >
                        Download
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="col-12 col-md-8">
              {this.state.lesson_plans.map((lesson_plan) => {
                return (
                  <div>
                    <div className="materials-required">
                      <h2 className="mt-0">Materials Required</h2>
                      <div>{m.trust(lesson_plan.materials_required())}</div>
                    </div>
                    <div className="procedure">
                      <h2 className="mt-0">Procedure</h2>
                      <div>{m.trust(lesson_plan.procedure())}</div>
                    </div>

                    <div className="vocabulary">
                      <h3 className="mt-0">Vocabulary/Language</h3>
                      <div>{m.trust(lesson_plan.vocabulary_language())}</div>
                    </div>

                    <div className="children_may_interest">
                      <h3 className="mt-0">Children may be interested in</h3>
                      <div>{m.trust(lesson_plan.children_may_interest())}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="LessonPlanDirector">{this.loading}</div>
      </div>
    );
  }

  /**
   * Our own sidebar. Re-uses Index.sidebarItems as the base
   * Elements added here will only show up on the user directory page
   *
   * @return {ItemList}
   */
  sidebarItems() {
    const items = IndexPage.prototype.sidebarItems();

    items.setContent(
      'nav',
      SelectDropdown.component(
        {
          buttonClassName: 'Button',
          className: 'App-titleControl',
        },
        this.navItems().toArray()
      )
    );

    return items;
  }

  /**
   * Our own sidebar navigation. Re-uses Index.navItems as the base
   * Elements added here will only show up on the user directory page
   *
   * @return {ItemList}
   */
  navItems() {
    const items = IndexPage.prototype.navItems();
    const params = this.stickyParams();

    items.remove('allDiscussions');
    items.remove('following');
    items.remove('tags');
    items.remove('tag1');
    items.remove('separator');

    items.add(
      'td-lesson-plans',
      LinkButton.component(
        {
          href: app.route('lesson_plans', params),
          icon: 'far fa-address-book',
        },
        app.translator.trans('td-lesson-plans.forum.page.nav')
      ),
      85
    );
    return items;
  }

  groupItems() {
    const items = new ItemList();

    app.store
      .all('groups')
      .filter((group) => group.id() !== '2' && group.id() !== '3')
      .forEach((group) => {
        items.add(
          group.namePlural(),
          CheckableButton.component(
            {
              className: 'GroupFilterButton',
              icon: group.icon(),
              checked: this.enabledGroupFilters.includes(group.id()),
              onclick: () => {
                const id = group.id();
                if (this.enabledGroupFilters.includes(id)) {
                  this.enabledGroupFilters = this.enabledGroupFilters.filter((e) => e != id);
                } else {
                  this.enabledGroupFilters.push(id);
                  // Empty the special group filters
                  this.enabledSpecialGroupFilters = [];
                }

                this.changeParams(this.params().sort);
              },
            },
            group.namePlural()
          )
        );
      });

    if (app.initializers.has('flarum-suspend') && app.forum.attribute('hasSuspendPermission')) {
      items.add(
        'suspend',
        CheckableButton.component(
          {
            className: 'GroupFilterButton',
            icon: 'fas fa-ban',
            checked: this.enabledSpecialGroupFilters['flarum-suspend'] === 'is:suspended',
            onclick: () => {
              const id = 'flarum-suspend';
              if (this.enabledSpecialGroupFilters[id] === 'is:suspended') {
                this.enabledSpecialGroupFilters[id] = '';
              } else {
                this.enabledSpecialGroupFilters[id] = 'is:suspended';
                // Empty the group filters
                this.enabledGroupFilters = [];
              }

              this.changeParams(this.params().sort);
            },
          },
          app.translator.trans('flarum-suspend.forum.user_badge.suspended_tooltip')
        ),
        90
      );

      items.add('seperator', Separator.component(), 50);
    }

    return items;
  }

  stickyParams() {
    return {
      id: m.route.param('id'),
    };
  }

  params() {
    return this.stickyParams();
  }
}
